// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import { __ } from '../../../../i18n/l10n';
import Toggle from '../buttons/Toggle';

const Wrap = styled.div`
  margin: 1em 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
`;

const Span = styled.span`
  color: ${({ $isDark, theme }) => ($isDark ? theme.grids.colors.black : '#fff')};
  margin-left: 1em;
`;

type Props = {
  className?: string;
  isPrivate: boolean;
  isDark?: boolean;
  togglePrivate: () => void;
};

const GridsTogglePrivate = ({ isPrivate, togglePrivate, className, isDark = false }: Props) => {
  return (
    <Wrap className={className} onClick={togglePrivate}>
      <Toggle isChecked={isPrivate} data-testid="grid-private-button" />
      <Span $isDark={isDark}>{__('By ticking this box, your grid will be made private.')}</Span>
    </Wrap>
  );
};

export default GridsTogglePrivate;
